<template>
  <img
    v-if="src && isFileFormatSvg"
    :src="src"
    :class="$attrs.class"
    class="size-full object-cover"
    :loading="lazy ? 'lazy' : undefined"
    :alt="$attrs.alt as string || src"
  />
  <picture v-else-if="src" :class="[$attrs.class, 'ui-picture']">
    <template v-for="extension in extensions">
      <source
        v-for="(option, key) in sizeOptions"
        :key="extension + key"
        :srcset="getImageProxyUrl(src, option, extension)"
        :media="`(max-width: ${breakpoints[key]})`"
        type="image/webp"
      />
    </template>
    <source :srcset="pictureUrl.webp" type="image/webp" />
    <img
      v-bind="{ src, ...$attrs }"
      class="size-full object-cover"
      :loading="lazy ? 'lazy' : undefined"
      :alt="$attrs.alt as string || src"
    />
  </picture>
  <div v-else :class="$attrs.class" class="w-full bg-pattern object-cover" />
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { PictureSizesOptions, PictureExtension } from 'img-proxy'

const props = defineProps({
  src: {
    type: String,
    required: false,
    default: '',
  },
  options: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  sizeOptions: {
    type: Object as PropType<PictureSizesOptions>,
    default: () => ({}),
  },
  lazy: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const { getImageProxyUrl } = usePicture()

const pictureUrl = computed(() => {
  return {
    webp: props.src && getImageProxyUrl(props.src, props.options, 'webp'),
  }
})

const imgFormat = computed(
  (): PictureExtension =>
    props.src?.slice(props.src?.lastIndexOf('.') + 1) as PictureExtension,
)

const extensions = computed((): PictureExtension[] => {
  const extensions = ['webp']

  extensions.push(imgFormat.value)

  return extensions as PictureExtension[]
})

const isFileFormatSvg = computed(() => props.src?.split('.').pop() === 'svg')
</script>

<script lang="ts">
export default defineComponent({
  inheritAttrs: false,
})
</script>
